import { Box, Modal } from '@mui/material';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useDropzone } from 'react-dropzone';
import { Code as Cd } from '@mui/icons-material';
import { useState } from 'react';

import BaseInputValidation from '@/components/ui/Input/BaseInputValidation';
import ButtonCloseModal from '@/components/ui/Button/ButtonCloseModal';
import ModalStyle from '@/constants/ModalStyle';
import usePatch from '@/hooks/usePatch';
import { toast } from 'react-toastify';

const schema = yup.object().shape({
	productprefix: yup.string().required('name is a required field'),
});

export default function Code(props) {
	const { open, onClose, data } = props;

	const [file, setFile] = useState(data?.icon && data?.icon !== 'No icon' ? data?.icon : null);

	const isEdit = !!data;
	const isImgLink = file && typeof file === 'string' ? file : file?.preview ? file.preview : null;

	const { getRootProps, getInputProps } = useDropzone({
		accept: {
			'image/*': [],
		},
		multiple: false,
		onDrop: (file) => {
			const f = Object.assign(
				{},
				{
					file,
					preview: URL.createObjectURL(file[0]),
				}
			);
			setFile(f);
		},
	});

	const {
		handleSubmit,
		control,
		reset,
		formState: { errors },
	} = useForm({
		resolver: yupResolver(schema),
		defaultValues: {
			productprefix: data?.productprefix || '',
		},
	});

	const handleClose = () => {
		reset();
		onClose();
	};

	const { mutate: codeAction } = usePatch({
		url: !isEdit ? `productprefix` : `productprefix/${data?.productprefixid}`,
		method: isEdit ? 'patch' : 'post',
		type: 'form-data',
		callback: async (res) => {
			if ([200, 201].includes(res.status) && res.data) {
				toast.success(res.data?.message || `Code ${res.status === 200 ? 'updated' : 'created'} successfully`);
			}
			props.onSave();
			handleClose();
		},
		onError: () => {
			handleClose();
		},
	});

	const onSubmit = (data) => {
		if (!data.productprefix) return;
		const fData = new FormData();
		fData.append('productprefix', data.productprefix);
		fData.append('status', 0);
		fData.append('validate', 0);
		fData.append('project', 0);
		fData.append('public', 0);
		if (file?.file) {
			fData.append('icon', file.file[0]);
		}

		codeAction(fData);
	};
	return (
		<Modal open={open} onClose={handleClose} aria-labelledby='modal-notes' aria-describedby='modal-notes' className='w-full'>
			<Box sx={{ ...ModalStyle, top: '25%' }} className='flex flex-col gap-4 w-[90%] md:w-[380px]'>
				<span className='text-2xl modal-title'>{isEdit ? `Edit (${data.name})` : 'Legg til ny Kode'}</span>
				<ButtonCloseModal onClose={handleClose} />

				<hr />

				<form onSubmit={handleSubmit(onSubmit)} className='flex flex-col w-full gap-4'>
					<div className='flex flex-col items-center justify-center w-32 h-32 gap-2 mx-auto'>
						<div className='w-full h-full p-2 bg-white'>
							{isImgLink ? (
								<img src={isImgLink} className='object-contain w-full h-full' />
							) : (
								<div className='bg-[#D1D1D1] w-full h-full rounded-full flex'>
									<Cd fontSize='large' className='m-auto' />
								</div>
							)}
						</div>
					</div>
					<div {...getRootProps({ className: 'dropzone w-full flex flex-col gap-2 cursor-pointer' })}>
						<div className='flex items-center gap-4'>
							<label className='flex items-center'>
								<input {...getInputProps()} />
								<button className='h-10 px-4 text-white border border-gray-700 rounded-sm bg-bd-blue' type='button'>
									<span>Velg filer</span>
								</button>
							</label>
							{!file && <span>Ingen fil valgt</span>}
						</div>
					</div>
					<BaseInputValidation control={control} name='productprefix' label='Code Name' errors={errors} required />

					<hr />

					<div className='flex gap-4 ml-auto'>
						<button className='px-3 py-2 text-white rounded-md btn bg-primary' type='submit'>
							{isEdit ? 'Oppdater' : 'Legg til'}
						</button>
					</div>
				</form>
			</Box>
		</Modal>
	);
}
